import { Usuario } from './usuario';

export class Caja {
  id: number;
  usuario: Usuario;
  isOpen: Boolean;
  importe: number;
  saldo: number;
  ingresos: number;
  egresos: number;
  debitos: number;

  constructor() {
  }
}